import { IComponent, IOption } from '../../../interfaces';
import BaseSingleSelect from './base-single-select';
import { useProps } from '../../../hooks/use-props';
import { useEffect } from 'react';

export interface ISingleSelectProps {
  id: string;
}

export interface IInternalSingleSelectProps {
  id: string;
  className?: string;
  label: string;
  error?: string;
  placeholder?: string;
  options: string[];
  freeSolo?: boolean;
  value: string;
  required?: boolean;
  onSelect: (value: string) => void;
  onChange?: (value: string) => void;
}

interface ISingleSelectAtom extends IComponent {
  value: IOption;
  answer: IOption;
  error?: string;
}

const useSingleSelect = (id: string) => {
  const { props, addAnswer } = useProps<ISingleSelectAtom>({
    id,
    initial_state: { id: '', label: '' },
  });

  const setValue = (label: string) => {
    const answer = props?.options?.find((option) => option.label === label);
    if (answer) return addAnswer({ answer: answer.id });
  };

  useEffect(() => {
    if (props.answer && props.options && props.options.length > 0) {
      addAnswer({ answer: props.answer });
    }
  }, [props.options]);

  return { props, setValue };
};
const SingleSelect = ({ id }: ISingleSelectProps) => {
  const {
    props: { label = '', options = [], value, error, show, required },
    setValue,
  } = useSingleSelect(id);
  if (!show) return null;
  return (
    <BaseSingleSelect
      id={id}
      label={label}
      options={options.map((o) => o.label)}
      value={value.label || ''}
      error={error}
      required={required}
      onSelect={(value) => {
        if (value) setValue(value);
      }}
    />
  );
};

export default SingleSelect;
